import React from 'react'
import TalentAppStep from "../components/TalentAppStep";
import ProfileLinkForm from "../components/ProfileLinkForm";
import ProfileDocumentForm from "../components/ProfileDocumentForm";

export default class LinksDocumentsStep extends TalentAppStep
{
    static path = '/links-documents';
    static LastUpdatedMethod = 'lastUpdatedLinksDocs';

    /**
     * The title shown on the form
     */
    static StepTitle = TB.trans('talent.links_documents.step_title');
    /**
     * The subtitle shown on the form
     */
    static StepSubtitle = TB.trans('talent.links_documents.step_subtitle');
    /**
     * The start page info tile
     */
    static StepInfo = TB.trans('talent.links_documents.step_info');
    /**
     * Show brief details for user
     */
    static ProfileSectionSummary = (user) => {
        if(!this.hasCompleted(user)) return false;
        return `${user.profile_links?.length} Links/${user.profile_documents?.length} Documents`;
    };

    static hasCompleted(user)
    {
        let items = TB.pick(user, ['profile_links', 'profile_documents']);

        items = TB.flatten(TB.values(items));

        items = TB.filter(items, item => TB.isDefined(item?.type))

        return items.length > 0;
    }

    /**
     * Check if we should prevent application from saving and show alert
     */
    static async getValidProps(user) {
        return user.validateLinksDocuments()
    };
    /**
     * [Constructor]
     *
     * @param {Object} props
     * @returns {FormPage}
     */
    constructor(props)
    {
        super(props);
    }

    renderFormFooter() {

        return (
            <div className="pb-6">
                <div>
                    {this.renderChildForm({
                        displayName: TB.trans('talent.links_documents.link_form_display_name'),
                        ChildFormComponent: ProfileLinkForm,
                        userProp: 'profile_links'
                    })}
                </div>

                <div style={{marginTop: 25}}>
                    {this.renderChildForm({
                        displayName:TB.trans('talent.links_documents.document_form_display_name'),
                        ChildFormComponent: ProfileDocumentForm,
                        userProp: 'profile_documents'
                    })}
                </div>
            </div>
        )
    }
}
